@if(offer()){
    <div class="header relative">
        <div class="title f-cross-center py-2 px-8">
            @if(branded()){
                <img class="brand-logo mr-5" [src]="brand().logo_url | bucket" [alt]="brand().name" [title]="brand().name" [fallback]/>
                <p class="m-0 font-semibold">{{brand().short || brand().name}}</p>
            }
            <p class="m-0 font-semibold">Loyalty Rewards</p>
        </div>
        <img class="rocket absolute" src="/images/rocket.png"/>
    </div>
    <div class="body py-10 px-12 text-center">
        <small class="m-0 shade1">
            @if(timer()){
                In less than {{timer()}} hour{{timer() == 1 ? '' : 's'}}, your next redemptions will start to count towards loyalty again
             } @else if(nextReward() == 0){
                Awesome, your next redemption is upgraded!
            } @else {
                {{nextReward()}} redemption{{nextReward() == 1 ? '' : 's'}} left for your next reward
            }
        </small>
        <div class="flat">
            <div class="my-8 steps f-col f-cross-center">
                <div class="row f-cross-center">
                    @for(step of steps(); let index = $index; let last = $last; track index){
                        <ng-container *ngTemplateOutlet="stepTemplate; context: { $implicit: step, index: index+1, last }"/>
                    }
                </div>
            </div>
        </div>
        <div class="stacked">
            <div class="my-8 steps f-col f-cross-center">
                @for(row of rows(); let row_index = $index; let odd = $odd; let last_row = $last; track row_index){
                    <div class="row f-cross-center" [style.width.px]="rowWidth()" [class.rtl]="odd">
                        @for(tile of row; let column_index = $index; let last_column = $last; track column_index){
                            @let index = ((row_index)*columnCount())+(column_index+1);
                            <ng-container *ngTemplateOutlet="stepTemplate; context: { $implicit: tile, index, last: last_column }"/>
                        }
                    </div>
                    @if(!last_row){
                        <div class="row-connector f-cross-center" [class.rtl]="!odd">
                            <div class="row-gap"></div>
                            @for(empty of row.slice(1); track $index){
                                <div class="empty-gap"></div>
                            }
                        </div>
                    }
                }
            </div>
        </div>
        <button class="info-button rounded font-bold py-8 interactive" (click)="moreInfo()">MORE INFO</button>
    </div>
}

<ng-template #stepTemplate let-step let-index="index" let-last="last">
    @let progress = offer().tiered_progress?.progress || 0;
    @let isReward = !!step.tier;
    @let isCompleted = progress >= index;
    @let isNext = progress == (index-1);
    @let isNextPending = isNext ? timer() : 0;

    <div class="step f-main-center f-cross-center" [class.reward]="isReward" [class.completed]="isCompleted" [class.active]="isReward && isNext && !isNextPending">
        @if(isCompleted){
            <mat-icon class="sized" style="--icon-size: 32px;">check</mat-icon>
        } @else if(isNextPending){
            <mat-icon class="sized" style="--icon-size: 32px;">{{clock_states[isNextPending]}}</mat-icon>
        } @else {
            <p class="m-0 font-semibold">{{step.tag_value}}</p>
        }
    </div>
    @if(!last){
        <div class="column-gap" [class.reward]="isCompleted" [class.completed]="progress > index"></div>
    }

</ng-template>

<ng-template #popup>
    <div class="popup" [style.--shade-1]="shade1()" [style.--shade-2]="shade2()" [style.--shade-3]="shade3()" [style.--shade-4]="shade4()">
        <p class="m-0 p-8">
            @if(timer()){
                In less than {{timer()}} hour{{timer() == 1 ? '' : 's'}}, your next redemptions will start to count towards loyalty again
            } @else {
                {{nextReward()}} redemption{{nextReward() == 1 ? '' : 's'}} left for your next reward
            }
        </p>
        <div class="stacked py-1">
            <div class="my-8 steps f-col f-cross-center">
                @for(row of rows(); let row_index = $index; let odd = $odd; let last_row = $last; track row_index){
                    <div class="row f-cross-center" [class.rtl]="odd">
                        @for(tile of row; let column_index = $index; let last_column = $last; track column_index){
                            @let index = ((row_index)*columnCount())+(column_index+1);
                            <ng-container *ngTemplateOutlet="stepTemplate; context: { $implicit: tile, index, last: last_column }"/>
                        }
                    </div>
                    @if(!last_row){
                        <div class="row-connector f-cross-center" [class.rtl]="!odd">
                            <div class="row-gap"></div>
                            @for(empty of row.slice(1); track $index){
                                <div class="empty-gap"></div>
                            }
                        </div>
                    }
                }
            </div>
        </div>
        <div class="reward-list p-8" style="max-width: 320px; margin: 0 auto;">
            @for(step of steps(); track $index){
                @if(step.tier){
                    <div class="f-cross-center">
                        <mat-icon class="sized mr-10" style="--icon-size: 30px;">star</mat-icon>
                        <p class="m0">After {{$index}} redemption{{$index == 1 ? '' : 's'}}, you can redeem {{step.tag_value}}</p>
                    </div>
                }
            }
        </div>
        <div class="terms p-8">
            <h3 class="m-0">Terms</h3>
            @for(term of offer().tier_tree?.terms||[]; track $index){
                <p class="my-5 px-8">
                    {{term}}
                </p>
            }
        </div>
    </div>
</ng-template>